module.exports = function () {
    $(document).ready(function () {

        var jstreeModule = require('jstree'); // jstree library
        var AjaxController = require('./../../services/AjaxController');

	    var $jsTree = $('#js-expenditure-jstree');

	    $jsTree.jstree({
		    "core" : {
			    "check_callback" : function (operation, node, parent, position, old_position, more) {
				    if(operation === "move_node") {

					    if(parent.id === "#") {
						    return false; // prevent moving a child above or below the root
					    }

					    var newParent = parent,
							oldParent = $jsTree.jstree(true).get_node(node.parent);

						if(newParent.data.type != 'category' || oldParent.data.type != 'category'){
							return false;
						}

					    if(newParent.id !== oldParent.id){
					    	return true;
					    }

					    return false;

				    }
				    return true; // allow everything else
			    }
		    },

		    "plugins" : [ "wholerow", "dnd" ]
	    });

	    $jsTree.on("move_node.jstree", function (event, data) {
		    var node = data.node,
				parent = $jsTree.jstree(true).get_node(data.parent);

	       /** Prepare and run AJAX*/
	       var url = '/api/expenditures/types/' + node.data.numericId + '/update';
	       var data = { category_id: parent.data.numericId };

	       var success = function (response) {
	       }

	       var error = function (response) {
	       	console.log('Error');
	       }

	       /** Send AJAX request */
	       AjaxController.prototype.send(url, data, success, error);
	    })


    });
}();
